/* np-design-refresh.js — button skin classifier (2026-06-12).
   Several template JSONs embed page-scoped CSS that re-colors
   .button--solid (e.g. ".button--solid{background:#00cd7f !important}")
   from body <style> blocks, which beat the static skin rules in
   np-design-refresh.css. This pass reads each solid button's COMPUTED
   color and tags it np-skin-green / np-skin-black; the companion CSS
   then applies the matching handoff skin at higher specificity. So a
   button keeps the COLOR the page intended — it just gets the new look. */
(function () {
  if (window.__npDesignRefresh) return;
  window.__npDesignRefresh = true;

  function parse(v) {
    var m = (v || '').match(/rgba?\((\d+), ?(\d+), ?(\d+)(?:, ?([\d.]+))?\)/);
    return m ? { r: +m[1], g: +m[2], b: +m[3], a: m[4] === undefined ? 1 : +m[4] } : null;
  }

  /* SOLID restyle 2026-06-12 v3 (was gradients) */
  var GREEN_GRAD = '#1AA86C';
  var BLACK_GRAD = '#0C0C0E';

  function classify(el) {
    if (el.__npSkinDone) return;
    el.__npSkinDone = true;
    /* let the page's own override (if any) win the COLOR decision. Note:
       buttons already skinned by the static CSS rules compute a transparent
       background-color (the gradient lives in background-image), so they
       are skipped here — only page-overridden solid-color buttons classify. */
    var c = parse(getComputedStyle(el).backgroundColor);
    if (!c || c.a < 0.4) return;
    if (c.g > 90 && c.g > c.r + 25 && c.g > c.b + 25) {
      el.classList.add('np-skin-green');
      /* inline !important — the only thing that beats the template-JSON
         section blobs (#shopify-section-… .button--solid {…!important}) */
      el.style.setProperty('background', GREEN_GRAD, 'important');
      el.style.setProperty('border', 'none', 'important');
    } else if (c.r < 70 && c.g < 70 && c.b < 70) {
      el.classList.add('np-skin-black');
      el.style.setProperty('background', BLACK_GRAD, 'important');
    }
    /* anything else (gray disabled, blue, custom) keeps its own look */
  }

  function run() {
    document.querySelectorAll('.button--solid:not(.anotherTransfer)').forEach(classify);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  /* late-rendered buttons (ajax cart re-renders, popups) */
  var mo = new MutationObserver(function () {
    clearTimeout(window.__npSkinT);
    window.__npSkinT = setTimeout(run, 150);
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });

  /* ── upload UX layer (2026-06-12) ───────────────────────────────────
     1) ERROR PANEL (mock format, original copy): hooked at the SOURCE —
        we wrap window.fileValidate() (classic global in custom-uploader.js)
        instead of watching classes with a MutationObserver. When it
        rejects a file it has already added drop-disabled-size/type to
        #uploadArea, so we read which and show the redesigned panel
        persistently; a later valid file clears it.
     2) FULL-PAGE DROP OVERLAY: dragging a file anywhere over an upload
        PDP shows a green full-viewport overlay (NT-style, NP green) and
        ANY drop routes into the same uploadFile() flow. This also fixes
        the stuck drag-glow dead-zone: dropping outside #uploadArea used
        to be silently swallowed (body preventDefault) leaving the glow
        classes stuck — it looked like a freeze with no error. Every
        overlay hide now clears those glow classes too. */
  function initUploadUX() {
    var ua = document.getElementById('uploadArea');
    if (!ua || ua.__npUxWired) return;
    var panel = ua.querySelector('.np-uerr');
    var fi = document.getElementById('fileInput');
    if (!panel) return;
    ua.__npUxWired = true;

    function showErr() {
      var kind = ua.classList.contains('drop-disabled-size') ? 'size' : 'type';
      panel.setAttribute('data-kind', kind);
      ua.classList.add('np-uerr-active');
    }
    function clearErr() {
      ua.classList.remove('np-uerr-active', 'drop-disabled-size', 'drop-disabled-type');
    }

    /* hook the validator once it exists (custom-uploader.js is deferred too) */
    var hookTries = 0;
    var hookIv = setInterval(function () {
      hookTries++;
      if (typeof window.fileValidate === 'function' && !window.fileValidate.__npWrapped) {
        var orig = window.fileValidate;
        window.fileValidate = function () {
          var ok;
          try { ok = orig.apply(this, arguments); }
          catch (err) { ok = false; ua.classList.add('drop-disabled-type'); }
          if (ok) { clearErr(); } else { showErr(); }
          return ok;
        };
        window.fileValidate.__npWrapped = true;
      }
      /* Close the Price Calculator popup the moment ANY file enters the
         upload flow (drop into its box, Browse picker, or the page-wide
         overlay) — it used to stay open over the post-upload screen. */
      if (typeof window.uploadFile === 'function' && !window.uploadFile.__npWrapped) {
        var origUp = window.uploadFile;
        window.uploadFile = function () {
          try {
            var pcOvl = document.querySelector('.customTabelPopup__overlay.pricing-table');
            if (pcOvl && getComputedStyle(pcOvl).display !== 'none') {
              var pcX = pcOvl.querySelector('.customTabelPopup__close');
              if (pcX) { pcX.click(); } else { pcOvl.style.display = 'none'; }
            }
          } catch (err) { /* defensive */ }
          return origUp.apply(this, arguments);
        };
        window.uploadFile.__npWrapped = true;
      }
      if ((window.fileValidate && window.fileValidate.__npWrapped && window.uploadFile && window.uploadFile.__npWrapped) || hookTries > 50) clearInterval(hookIv);
    }, 200);

    /* panel clicks: never bubble to #uploadArea (its click handler opens
       the file picker); buttons act explicitly. */
    panel.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!e.target.closest('.np-uerr__btn--upload')) return;
      e.preventDefault();
      clearErr();
      if (fi) fi.click();
    });

    /* ── full-page drop overlay ── */
    var ov = document.createElement('div');
    ov.className = 'np-dropov';
    ov.innerHTML =
      '<div class="np-dropov__inner">' +
        '<svg class="np-dropov__cloud" viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" style="fill:#FFFFFF"/>' +
          '<path d="M12 9.4l3 3.1h-2v3.4h-2v-3.4H9z" style="fill:#1AA86C"/>' +
        '</svg>' +
        '<div class="np-dropov__title">Drop your file</div>' +
        '<div class="np-dropov__sub">anywhere to upload</div>' +
      '</div>';
    document.body.appendChild(ov);

    var depth = 0;
    /* 'first' = pre-upload (main dropzone visible); 'second' = post-upload
       with the "add another" box on screen — the page-wide overlay works
       for both, routing to the matching uploadFile flow. */
    function dropMode() {
      if (!ua.classList.contains('hidden')) return 'first';
      /* post-upload: the add-another box EXISTS but stays hidden until the
         form validates — treat its presence as second-mode so an early
         drop surfaces the required-fields error instead of doing nothing. */
      if (document.querySelector('.secondDropZone')) return 'second';
      return null;
    }
    function uploadable() { return dropMode() !== null; }
    function hideOv() {
      depth = 0;
      ov.classList.remove('is-on');
      /* clear the legacy drag-glow state wherever it stuck */
      document.querySelectorAll('.file-upload-overlay-1, .file-upload-overlay-2').forEach(function (el) {
        el.classList.remove('active');
      });
      document.body.classList.remove('file-upload-overlay-1-active', 'file-upload-overlay-2-active');
    }
    function routeDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      var m = dropMode();
      hideOv();
      clearErr();
      if (!f || typeof window.uploadFile !== 'function') return;
      if (m === 'second') {
        /* Same gate as the proceed-to-checkout path: every required option
           must be picked before a second design can be added. PRIMARY
           signal = .cta-wrapper-box.validated (the exact state checkout
           clicks are gated on, maintained by the theme's mutedcheck flow);
           __npSecondUploadValid() as a second opinion — it fail-opens when
           the options app hasn't rendered (#bcpo missing), which let an
           early drop through. Reject and surface the theme's own
           mandatory-field errors. */
        var gateBox = document.querySelector('.cta-wrapper-box');
        var notValidated = gateBox && !gateBox.classList.contains('validated');
        var helperSaysNo = typeof window.__npSecondUploadValid === 'function' && !window.__npSecondUploadValid();
        if (notValidated || helperSaysNo) {
          if (typeof window.__npSecondUploadShowError === 'function') window.__npSecondUploadShowError();
          return;
        }
        /* mirror the native .secondDropZone drop handler */
        window.anotherTransfer = true;
        if (typeof window.isPuffProduct !== 'undefined' && window.isPuffProduct) window.anotherPuff = true;
        window.uploadFile(f, 'second_image');
      } else {
        window.uploadFile(f);
      }
    }
    document.addEventListener('dragenter', function (e) {
      if (!uploadable()) return;
      var types = (e.dataTransfer && e.dataTransfer.types) || [];
      if (Array.prototype.indexOf.call(types, 'Files') === -1) return;
      depth++;
      ov.classList.add('is-on');
    });
    document.addEventListener('dragleave', function () {
      if (depth > 0) depth--;
      if (depth <= 0 && ov.classList.contains('is-on')) hideOv();
    });
    document.addEventListener('dragover', function (e) {
      if (ov.classList.contains('is-on')) e.preventDefault();
    });
    ov.addEventListener('dragover', function (e) { e.preventDefault(); });
    ov.addEventListener('drop', routeDrop);
    document.addEventListener('drop', function (e) {
      if (ov.classList.contains('is-on')) routeDrop(e);
    });
    window.addEventListener('dragend', hideOv);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUploadUX);
  } else { initUploadUX(); }

  /* ── full-page drop overlay for the AI TOOL pages (Background Remover,
     Upscaler) — same UX as product pages. These widgets reuse the
     .upload-area/#dropZoon/#fileInput structure but have no #uploadArea
     wrapper and no global uploadFile(); routing = assign the files to
     the tool's own input + fire change, which runs its native flow. */
  function initToolOverlay() {
    /* Wired once on every page; all gating happens at EVENT time because
       the members portal loads the Background Remover / Upscaler tabs via
       AJAX — their upload box doesn't exist at script init, and tab
       switches can replace the input. PDP uploaders (identified by the
       .np-uerr panel) keep their own overlay; this one stays inert there. */
    if (window.__npToolOvWired) return;
    window.__npToolOvWired = true;
    function toolInput() {
      if (document.querySelector('#uploadArea .np-uerr')) return null; /* PDP */
      return document.querySelector('.upload-area #fileInput, #upload_area input[type="file"]');
    }
    var ov = document.createElement('div');
    ov.className = 'np-dropov';
    ov.innerHTML =
      '<div class="np-dropov__inner">' +
        '<svg class="np-dropov__cloud" viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" style="fill:#FFFFFF"/>' +
          '<path d="M12 9.4l3 3.1h-2v3.4h-2v-3.4H9z" style="fill:#1AA86C"/>' +
        '</svg>' +
        '<div class="np-dropov__title">Drop your file</div>' +
        '<div class="np-dropov__sub">anywhere to upload</div>' +
      '</div>';
    document.body.appendChild(ov);
    var depth = 0;
    function hideOv() { depth = 0; ov.classList.remove('is-on'); }
    function routeDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      var files = e.dataTransfer && e.dataTransfer.files;
      hideOv();
      if (!files || !files.length) return;
      var fi = toolInput(); /* fresh query — ajax tab switches replace it */
      if (!fi) return;
      try {
        fi.files = files;
        fi.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) { /* defensive */ }
    }
    document.addEventListener('dragenter', function (e) {
      if (!toolInput()) return; /* no tool uploader in the current view */
      var types = (e.dataTransfer && e.dataTransfer.types) || [];
      if (Array.prototype.indexOf.call(types, 'Files') === -1) return;
      depth++;
      ov.classList.add('is-on');
    });
    document.addEventListener('dragleave', function () {
      if (depth > 0) depth--;
      if (depth <= 0 && ov.classList.contains('is-on')) hideOv();
    });
    document.addEventListener('dragover', function (e) {
      if (ov.classList.contains('is-on')) e.preventDefault();
    });
    ov.addEventListener('dragover', function (e) { e.preventDefault(); });
    ov.addEventListener('drop', routeDrop);
    document.addEventListener('drop', function (e) {
      if (ov.classList.contains('is-on')) routeDrop(e);
    });
    window.addEventListener('dragend', hideOv);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToolOverlay);
  } else { initToolOverlay(); }
})();

/* Header compact-state flag (2026-06-12): the header section is
   position:sticky; top:-55px, so on scroll the MEMBERS AREA eyebrow clips
   and the store-credit line drops below the visible band. Toggle
   html.np-hdr-scrolled past 60px so the compact account button can show
   "My Account + Store Credits" (eyebrow hidden) — matches the reference. */
(function () {
  if (window.__npHdrScroll) return;
  window.__npHdrScroll = true;
  var root = document.documentElement, ticking = false;
  function apply() {
    ticking = false;
    if (window.scrollY > 60) root.classList.add('np-hdr-scrolled');
    else root.classList.remove('np-hdr-scrolled');
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(apply); }
  }, { passive: true });
  apply();
})();
